import { render, staticRenderFns } from "./MaterialDropdown.vue?vue&type=template&id=61bbc8be&"
import script from "./MaterialDropdown.vue?vue&type=script&lang=ts&"
export * from "./MaterialDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports